import handleColorChange from './handleColorChange';

export default () => {
  document.addEventListener(
    'mouseenter',
    (e) => {
      if (e.target instanceof Element) {
        const target = e.target.closest('[data-swatch-product-tile]');
        if (target) {
          const imageSrc = target.getAttribute('data-swatch-product-tile');
          const productImage = target.closest('.ProductTile').querySelector('.ProductTile__image img:first-child');
          if (productImage) {
            productImage.setAttribute('src', imageSrc);
          }
        }
      }
    },
    true,
  );

  const colorSelector = document.querySelector('[data-color-selector]');

  if (!colorSelector) {
    return false;
  }

  // Replacing the Selectric plugin with custom functionality
  const buildCustomSelect = (selectElement) => {
    selectElement.addEventListener('change', handleColorChange);

    // Custom rendering logic can be added here
  };

  buildCustomSelect(colorSelector);

  return true;
};
